import React from 'react';
import MessageCell from '@/components/table/MessageCell';

const VocabularyUrlsCell = ({ vocabulary }) => (
  <MessageCell
    className="td-description"
    messageId="items.count"
    messageArgs={{ count: vocabulary.urls.length }}
  />
);

export default VocabularyUrlsCell;
